import { ColumnKey } from './columnDefs';

export type ItemData = Record<string, unknown> & {
  columnOrderItem: true;
  columnKey: ColumnKey;
};

export function getItemData(columnKey: ColumnKey): ItemData {
  return { columnOrderItem: true, columnKey };
}

export function isItemData(data: Record<string, unknown>): data is ItemData {
  return data.columnOrderItem === true;
}
